// Firebase configuration — connects KarmaDal to your real Firebase project
// (Authentication for real logins, Firestore for the single-session check)
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCiBGocNsfMGaVXvtlTLajZtDz8ISpk6uA",
  authDomain: "karmadal-app.firebaseapp.com",
  projectId: "karmadal-app",
  storageBucket: "karmadal-app.firebasestorage.app",
  messagingSenderId: "714634283238",
  appId: "1:714634283238:web:67b51a093ff6ef54f59327",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
// Exported so Add Employee can spin up a brief, separate connection to create a new
// login without disturbing the admin's own signed-in session.
export { firebaseConfig };